module.exports = __webpack_public_path__ + "components/Game/Steps/CO2/CO2BenefitQuestionImage.82bccacca9f9a58395ef897a0fbb2adc.png";